export const PRODUCT_IMAGE_ACCEPT = 'image/jpeg,image/png,image/webp,image/gif';
export const PRODUCT_IMAGE_MAX_BYTES = 4 * 1024 * 1024;
export const PRODUCT_IMAGE_MAX_DIMENSION = 2000;

const ALLOWED_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/gif']);

export function validateProductImageFile(file: File): string | null {
  if (!ALLOWED_TYPES.has(file.type)) {
    return 'Only JPEG, PNG, WebP, and GIF images are allowed';
  }
  if (file.size > PRODUCT_IMAGE_MAX_BYTES) {
    return 'Image must be 4MB or smaller';
  }
  return null;
}

export function readProductImageFile(file: File): Promise<string> {
  const validationError = validateProductImageFile(file);
  if (validationError) {
    return Promise.reject(new Error(validationError));
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;
      if (typeof dataUrl !== 'string') {
        reject(new Error('Failed to read file'));
        return;
      }

      const img = new Image();
      img.onload = () => {
        if (
          img.width > PRODUCT_IMAGE_MAX_DIMENSION ||
          img.height > PRODUCT_IMAGE_MAX_DIMENSION
        ) {
          reject(
            new Error(
              `Image must be ${PRODUCT_IMAGE_MAX_DIMENSION}×${PRODUCT_IMAGE_MAX_DIMENSION}px or smaller`,
            ),
          );
          return;
        }
        resolve(dataUrl);
      };
      img.onerror = () => reject(new Error('Could not read image file'));
      img.src = dataUrl;
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
}
